// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2FkZX","inner":"Form_inner__3RyKl","range":"Form_range__vphMq","name":"Form_name__GckiF","actions":"Form_actions__3h6um"};